import clsx from 'clsx';
import PostCard, { PostType } from '../PostCard/PostCard';
import styles from './PostsList.module.scss';
import Pagination from '@/components/Pagination/Pagination';

interface PostsListProps {
  posts: PostType[];
  pagination: {
    page: number;
    pageCount: number;
    pageSize: number;
    total: number;
  };
  onPageChange: (page: number) => void;
}

const PostsList = ({ posts, pagination, onPageChange }: PostsListProps) => {
  const showPagination = pagination.pageCount > 1;

  return (
    <section className={clsx(styles.postsList, 'custom', { [styles.noPagination]: !showPagination })}>
      <section className={clsx(styles.posts, 'custom')}>
        {posts.map((post) => (
          <PostCard
            key={post.id}
            post={post}
          />
        ))}
      </section>
      {showPagination && (
        <Pagination
          totalPages={pagination.pageCount}
          currentPage={pagination.page}
          onPageChange={onPageChange}
          className={styles.pagination}
        />
      )}
    </section>
  );
};

export default PostsList;
